import { moment, _ } from "../../../../vendor";
const { random, range } = _;

const colorRangeGenerator = function* () {
  let x = 180;
  while (1) {
    yield [x + 0, x + 45];
    x = (x + 90) % 360;
  }
};

const getRange = colorRangeGenerator();
const colorGenerator = () => `hsla(${random(...getRange.next().value)}, 85%, 52%, 0.95)`;

//const colorPaletteGenerator = () => range(5).map(colorGenerator);
const colorPaletteGenerator = () => [
  "#008FFB",
  "#FF4560",
  "#FEB019",
  "#01e397",
  "#1f77b4",
  "#aec7e8",
  "#ff7f0e",
  "#ffbb78",
  "#2ca02c",
  "#98df8a",
  "#d62728",
  "#ff9896",
  "#9467bd",
  "#c5b0d5",
  "#8c564b",
  "#c49c94",
  "#e377c2",
  "#f7b6d2",
  "#7f7f7f",
  "#c7c7c7",
  "#bcbd22",
  "#dbdb8d",
  "#17becf",
  "#9edae5",
];

let customLabelHandle = false;

export default {
  axis: {
    x: {
      type: "timeseries",
      tick: {
        format: function (x) {
          return moment(x).format("MMM YY").toString();
        },
        rotate: -45,
        culling: false,
      },
    },
    y: {
      min: 0,
      padding: { bottom: 0 },
    },
  },
  grid: { y: { show: true } },
  data: { xFormat: "%Y-%m-%dT%H:%M:%SZ" },
  color: { pattern: colorPaletteGenerator() },
  padding: { right: 25 },
  onrendered: function () {
    const internal = this;
    if (internal.main === null) {
      return;
    }
    const main = internal.main;

    const labelSize = {
      basewidth: 14,
      offwidth: 4,
      height: 14,
    };
    const pointLocations = internal
      .getCircles()
      .nodes()
      .map((n) => ({
        value: n.__data__.value,
        x: n.cx.baseVal.value,
        y: n.cy.baseVal.value,
        color: internal.color(n.__data__.id),
        height: labelSize.height,
        width: labelSize.basewidth + labelSize.offwidth * ("" + n.__data__.value).length,
        opacity: n.parentNode.parentNode.style.display === "none" ? 0 : 1,
      }));

    // We find the size of rectangle using Regex on the draw path of <path>
    // It's hacky, but we don't have to recompute
    const num = "((?:-|)[\\.\\d]+)";
    const numGroup = `${num},${num}`;
    const bar4pts = `M ${numGroup} L${numGroup} L${numGroup} L${numGroup} z`;
    const bar4ptsRegex = new RegExp(bar4pts);
    const barLocations = internal
      .getBars()
      .nodes()
      .map((n) => ({
        value: n.__data__.value,
        xy: n.attributes["d"].value.match(bar4ptsRegex),
        opacity: n.style.opacity === "0" ? 0 : 1,
      }))
      .filter(({ xy }) => xy !== null)
      .map(({ xy, ...other }) => ({
        x: (Number(xy[3]) + Number(xy[5])) / 2,
        y: (Number(xy[2]) + Number(xy[4])) / 2,
        ...other,
      }));

    const textFormat = (hideZero) => (d) =>
      d
        .attr("x", (d) => d.x)
        .attr("y", (d) => d.y)
        .attr("dominant-baseline", "middle")
        .attr("text-anchor", "middle")
        .attr("fill", "#FFF")
        .style("font-weight", "bold")
        .style("opacity", (d) => d.opacity)
        .style("pointer-events", "none")
        .text((d) => (hideZero && d.value === 0 ? "" : d.value));

    const rectFormat = (d) =>
      d
        .attr("x", (d) => d.x - d.width / 2)
        .attr("y", (d) => d.y - d.height / 2)
        .attr("width", (d) => d.width)
        .attr("height", (d) => d.height)
        .attr("fill", (d) => d.color)
        .style("stroke-width", 1)
        .style("stroke", "#FFF")
        .style("opacity", (d) => d.opacity)
        .style("pointer-events", "none");

    const customLabelCN = "chart-custom-label";
    const customLabelRectCN = "chart-custom-label-rect";
    const customLabelTextCN = "chart-custom-label-text";

    const drawBarLabel = (labelData) => {
      // Exit
      labelData.exit().remove();
      // Enter
      const newLabelData = labelData.enter();
      const newLabelGroup = newLabelData.append("g").attr("class", customLabelCN);
      // Update
      // Correctly select our created elements
      labelData.select("text." + customLabelTextCN).call(textFormat(true));
      // New
      newLabelGroup.append("text").attr("class", customLabelTextCN).call(textFormat(true));
      // Merge (New + Update)
      newLabelData.merge(labelData);
    };

    const drawSplineLabel = (labelData) => {
      // Exit
      labelData.exit().remove();
      // Enter
      const newLabelData = labelData.enter();
      const newLabelGroup = newLabelData.append("g").attr("class", customLabelCN);
      // Update
      // Correctly select our created elements
      labelData.select("rect." + customLabelRectCN).call(rectFormat);
      labelData.select("text." + customLabelTextCN).call(textFormat(false));
      // New
      newLabelGroup.append("rect").attr("class", customLabelRectCN).call(rectFormat);
      newLabelGroup.append("text").attr("class", customLabelTextCN).call(textFormat(false));
      // Merge (New + Update)
      newLabelData.merge(labelData);
    };

    // Init
    if (!customLabelHandle) {
      // Creating wrapper: Doesn't work
      // main
      //     .select(internal.CLASS.chart)
      //     .append("g")
      //     .attr("class", "c3-custom-labels");
      customLabelHandle = true;
    }
    // Correctly select our created elements
    const label = main.selectAll("g." + customLabelCN);
    if (barLocations.length > 0) {
      label.data(barLocations).call(drawBarLabel);
    }
    if (pointLocations.length > 0) {
      label.data(pointLocations).call(drawSplineLabel);
    }
  },
  tooltip: {
    contents: function (data, defTitleFmt, defValueFmt, color) {
      const item = data
        .map(
          ({ name, id, index, value }) =>
            `
                    <li>
                        <svg height="10" width="10">
                            <circle cx="5" cy="5" r="5" fill="${color(id)}" />
                        </svg>
                        ${name}: <b>${value}</b>
                    </li>`,
        )
        .join("");
      const output = `
                <table id="chart-tooltip">
                    <tr>
                        <th>
                            ${defTitleFmt(data[0].x)}
                        </th>
                    </tr>
                    <tr>
                        <td>
                            <ul id="bare-list">${item}</ul>
                        </td>
                    </tr>
                </table>`;
      return output;
    },
  },
};
